import { useId } from 'react';
import { IconPropsType } from '..';

export const AffiliateColoredIcon = ({ ...props }: IconPropsType) => {
  const id = useId();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#clip0_23698_15803${id})`}>
        <path
          d="M8.3978 0.905763C9.36344 0.905763 10.1473 1.71459 10.1473 2.71097C10.1473 3.34397 9.8349 3.89491 9.35776 4.21727L9.76673 6.32139C10.6699 6.33898 11.4822 6.76097 12.0331 7.42328L13.7031 6.49136C13.7031 6.43275 13.6974 6.38 13.6974 6.32139C13.6974 5.35432 14.4586 4.56893 15.4015 4.56893C16.3444 4.56893 17.0999 5.35432 17.0999 6.32139C17.0999 7.28847 16.3388 8.07385 15.4015 8.07385C14.9925 8.07385 14.6233 7.92733 14.328 7.68116L12.658 8.61307C12.7318 8.88854 12.7773 9.1816 12.7773 9.48051C12.7773 10.1076 12.6012 10.6938 12.2944 11.1861L13.4702 12.3993C13.7883 12.2235 14.1462 12.1239 14.5268 12.1239C15.7707 12.1239 16.7761 13.1613 16.7761 14.4448C16.7761 15.7284 15.7707 16.7658 14.5268 16.7658C13.2828 16.7658 12.2774 15.7284 12.2774 14.4448C12.2774 14.0521 12.374 13.677 12.5444 13.3547L11.3686 12.1414C10.8914 12.4579 10.3234 12.6396 9.71561 12.6396C9.42592 12.6396 9.14191 12.5986 8.87494 12.5165L7.97178 14.2397C8.21035 14.5386 8.35236 14.9254 8.35236 15.3474C8.35236 16.3145 7.59121 17.0999 6.65397 17.0999C5.71673 17.0999 4.95558 16.3145 4.95558 15.3474C4.95558 14.3804 5.71673 13.595 6.65397 13.595C6.71077 13.595 6.76757 13.595 6.8187 13.6008L7.72185 11.8777C7.17655 11.3971 6.80166 10.7172 6.68805 9.9494L5.25664 9.84976C4.93286 10.7231 4.11491 11.3502 3.14927 11.3502C1.9053 11.3502 0.899902 10.3128 0.899902 9.02921C0.899902 7.74563 1.9053 6.70822 3.14927 6.70822C4.21715 6.70822 5.10895 7.47603 5.34184 8.50171L6.77326 8.60135C7.02887 7.69875 7.65937 6.96025 8.483 6.58514L8.07403 4.48102C7.26175 4.32277 6.64829 3.59013 6.64829 2.70511C6.64829 1.70873 7.43216 0.899902 8.3978 0.899902V0.905763Z"
          fill={`url(#paint0_linear_23698_15803${id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_23698_15803${id}`}
          x1="17.4373"
          y1="4.49985"
          x2="3.37485"
          y2="14.6248"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.564558"
            stopColor="currentColor"
          />
          <stop
            offset="0.566304"
            stopColor="#F0F0F0"
          />
        </linearGradient>
        <clipPath id="clip0_23698_15803">
          <rect
            width="18"
            height="18"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
